<template>
 <!-- <div id="clock">
    <span>{{ this.get_str_time_by_date(time) }}</span>  
    <div>
      <button class="btn btn-sm border" > ..日(..時) </button>
    </div>
    <div class="mb-2">
      <button class="btn btn-sm border" @click="this.time = new Date(2023,5,6,9)"> 6(09) </button>
      <button class="btn btn-sm border" @click="this.time = new Date(2023,5,6,12)"> 6(12) </button>
      <button class="btn btn-sm border" @click="this.time = new Date(2023,5,6,15)"> 6(15) </button>
      <button class="btn btn-sm border" @click="this.time = new Date(2023,5,7,9)"> 7(9) </button>
      <button class="btn btn-sm border" @click="this.time = new Date(2023,5,7,12)"> 7(12) </button>
      <button class="btn btn-sm border" @click="this.time = new Date(2023,5,7,15)"> 7(15) </button>
      <button class="btn btn-sm border" @click="this.time = new Date(2023,5,7,15,57)"> 7(15) </button>
      <button class="btn btn-sm border" @click="this.time = new Date(2023,5,7,10,57)"> 7(15) </button>
    </div>
    <div>
      <button class="btn btn-sm border" @click="this.addtime(60)"> + 1h </button>
      <button class="btn btn-sm border" @click="this.addtime(28)"> + 28 m </button>
      <button class="btn btn-sm border" @click="this.addtime(1)"> + 1 m</button>
      <button class="btn btn-sm border" @click="this.addtime(0.5)"> + 50s </button>
      <button class="btn btn-sm border" @click="this.addtime(0.1)"> + 1s </button>
    </div>
  </div>  -->
<!-- Banner -->
<div id="hero_area" style=" height: calc(80vh - 90px);">
  <div class="row position-relative w-100 mx-auto">
    <p class="text-center text-white fw-bold fs-5">「2024年問題」を見据えた、新時代のロジスティクスを支援する</p>
    <div id="top_banner">
      <div id="top_logo" class="text-center">
        <img src='@/assets/logo-color.png'  alt='ロゴ'>
      </div>
    </div>
    <!-- <div>
          <div id="currently_airing_webinar" class="side_button_wrapper" :class=" (is_airing_opened) ? 'open_info' : '' ">
            <div class="d-flex align-items-center">
              <button id="side_button" @click="toogle_button_airing()">
                現在開催中
              </button>
              <div v-if="check_currently_airing_webinar()" class="fs-3 mx-auto p-2 text-center">
                現在配信中のウェビナーはありません
              </div>
              <div v-else class="p-2 position-relative " style="padding-right: 30px !important;">
                <p class="side_button_description">
                  {{ currently_airing_webinar.webinar_start_at }}<br> 
                  <span id="side_btn_link" class="fw-bolder fs-3" @click="view_webinar(currently_airing_webinar.public_id)">{{ currently_airing_webinar.webinar_title }}<br> </span>
                  {{ currently_airing_webinar.company_name }}
                </p>
              </div>
              <button id="close_button" @click="toogle_button_airing()">
                <i class="fas fa-times fa-2x"></i>
              </button>
            </div>
          </div>
          <div id="next_webinar" class="side_button_wrapper" :class=" (is_airing_opened) ? 'open_info' : '' ">
            <div class="d-flex align-items-center">
              <button id="side_button" @click="toogle_button_airing()">
                次のウ ェビナ ー
              </button>
              <div v-if="check_next_webinar()" class="fs-3 mx-auto p-2 text-center">
                現在配信中のウェビナーはありません
              </div>
              <div v-else class="p-2 position-relative" style="padding-right: 30px !important;">
                <p class="side_button_description">
                  {{ next_webinar.webinar_start_at}} <br> 
                  <span id="side_btn_link" class="fw-bolder fs-3" @click="view_webinar(next_webinar.public_id)">{{ next_webinar.webinar_title }}<br> </span>
                  {{ next_webinar.company_name }}</p>
              </div>
            </div>
          </div>
    </div> -->

    <div id="top_date" class="text-center section-title fw-bold">
        <h2>アーカイブ配信中</h2>
    </div>

    <div id="top_button">
      <div class="wrapper row p-0 mx-auto justify-content-center">
        <a href="#timetable" class="col-sm-5 col-12 m-1" id="top-button">全てのスケジュールを見る</a>
        <a href="#attendance-section" class="col-sm-3 col-12 m-1" id="top-button">受講方法</a>
        <a href="https://webinarweek.net/webinar/entry/?thema_pid=TH_KzOTAlP8" target="_blank" class="col-sm-3 col-12 m-1" id="top-button">受講者登録</a>
      </div>
    </div>

  </div>
</div>

<div class="section-wrapper">
<!-- Section 1 (news / info) -->
  <div id="section-title" class="section-title">
    <h3>News & Topics</h3>
  </div>
  <MDBContainer>
    <section id="info-section" class="mb-4">
      <div id="info_list" class="wrapper" style="min-height: 200px;">
        <MDBListGroup flush>
          <MDBListGroupItem tag="router-link" :to="'/info/' + info.public_id" action v-for="info in webinar_information" :key="info.public_id">
            <div class="row">
              <div class="info_date col-sm-1 col-12">{{ dayjs(info.publish_start).format('YYYY年M月D日') }}
              </div>
              <div class="info_title flex-grow-1 col">{{ info.title }}</div>
            </div>
          </MDBListGroupItem>
        </MDBListGroup>
        <div class="nav">
          <router-link to="/info_list" class="text-decoration-none text-dark">お知らせ一覧を見る<i class="fas fa-caret-right fa-lg ms-2"></i></router-link>
        </div>
      </div>
    </section>
  </MDBContainer>
<!-- Section 2 (Webinar Week) -->
  <div id="possibility">
    <div class="wrapper h-100">
      <div id="section-title">
        <h3>物流業界の技術サービスをウェビナーで⼀挙に紹介 <br>
          〜物流危機を乗り越えるために〜</h3>
      </div>
      <div id="section-text">
        <p class="m-0 p-0"></p>
        <span id="timetable"></span>
      </div>
    </div>
  </div>
<!-- Section 3 (time table) -->
  <div id="time-table-wrapper" class="wrapper">
    
    <div id="section-title" class="section-title my-3">
      <h3>タイムテーブル</h3>
    </div>
  <!-- <div>
      <h2 class="fw-bold text-center" style="color:var(--primary-08)">準備中</h2>
  </div> -->
   <div class="time-table row mx-1">
    
    <div class="item col-2 col-md-1 bg-d8">
      <div class="nav nav-b w-100">      
        <h3 class="time-title">時間</h3>
      </div>
      <div v-for="(time, index) in time_list" :key="time">
          <div class="time-card" :class="[(index>2 && index <7) ? 'skipped' : '' ]">
            <p  class="desctiption text-center">
              <span>{{time}}</span>
            </p>
          </div>
      </div>
    </div>

    <div id="desktop_time_table" v-for="day in day_list" :key="day" class="item col" :class="[day == '2023-06-07' ? 'bg_even' : 'bg_odd']">
      <div v-if="day=='2023-06-06'" class="nav nav-odd w-100 fst-italic fs-4">
        <h3 class="w-100 mx-auto text-center text-white fst-italic fs-1">6/6 <span class="text-white fs-6">TUE</span></h3>
      </div>
      <div v-if="day=='2023-06-07'" class="nav nav-even w-100 fst-italic fs-4">
        <h3 class="w-100 mx-auto text-center text-white fst-italic fs-1">6/7 <span class="text-white fs-6">WED</span></h3>
      </div>
      <div v-if="day=='2023-06-08'" class="nav nav-odd w-100 fst-italic fs-4">
        <h3 class="w-100 mx-auto text-center text-white fst-italic fs-1">6/8<span class="text-white fs-6">THU</span></h3>
      </div>
      <div v-for="(webinar,index) in webinar_list[day]" :key="webinar.public_id" >
        <div v-if="webinar!='skipped'" class="webinar-card" @click="view_webinar(webinar.public_id)">
          <span class="time ps-3">  {{ webinar.webinar_start_at.substring(11, 16) }} ~ {{this.getWebinarEndTime(webinar.webinar_start_at.substring(11, 16))}}</span><br>
          <!-- <div class="desctiption text-start w-100">
            <span class="genre">「{{ webinar.genre_name }}」</span><br>
          </div>           -->
          <div class="desctiption text-start w-100" :class="'cat_bg_'+webinar.genre_key">
            <span class="webinar" >{{ webinar.genre_name }}</span><br>
          </div>        
          <div class="desctiption text-start w-100">
            <span class="webinar">「{{ webinar.webinar_title }}」</span><br>
          </div>
          <div class="desctiption text-start w-100 ">
            <span class="company">{{ webinar.company_name }}</span>
          </div>
        </div>   
        <div v-else :class="(webinar)" :id="webinar+index"></div>
      </div>
    </div>

    <div id="mobile_time_table" class="item col bg_odd">
      <div class="row m-0 p-0">
        <button class="nav col btn border p-0 m-0 rounded-0" :class="[(this.mobile_active_day==0) ? 'nav-odd' : 'nav-even']" @click="this.mobile_active_day=0">
          <h3 class="m-0 p-0 fst-italic fs-1">6/6 <span class="text-white fs-6">TUE</span></h3>
        </button>
        <button class="nav col btn border p-0 m-0 rounded-0" :class="[(this.mobile_active_day==1) ? 'nav-odd' : 'nav-even']"  @click="this.mobile_active_day=1">
          <h3 class="m-0 p-0 fst-italic fs-1">6/7 <span class="text-white fs-6">WED</span></h3>
        </button>
        <button class="nav col btn border p-0 m-0 rounded-0" :class="[(this.mobile_active_day==2) ? 'nav-odd' : 'nav-even']"  @click="this.mobile_active_day=2">
          <h3 class="m-0 p-0 fst-italic fs-1">6/8 <span class="text-white fs-6">THU</span></h3>
        </button>
      </div>
      <div v-for="(webinar,index) in webinar_list[this.day_list[mobile_active_day]]" :key="webinar.public_id" >
        <div v-if="webinar!='skipped'"  class="webinar-card" @click="view_webinar(webinar.public_id)">
          <span class="time ps-3">  {{ webinar.webinar_start_at.substring(11, 16) }} ~ {{this.getWebinarEndTime(webinar.webinar_start_at.substring(11, 16))}}</span><br>
          <!-- <div class="desctiption text-start w-100">
            <span class="webinar" >{{ webinar.genre_name }}</span><br>
          </div>         -->
          <!-- <span :class="'mx-auto text-center text-white p-1  bg_' + webinar.genre_key" v-if="webinar.genre_key">{{ webinar.genre_name }}</span> -->
          <div class="desctiption text-start w-100" :class="'cat_bg_'+webinar.genre_key">
            <span class="webinar" >{{ webinar.genre_name }}</span><br>
          </div>        
          <div class="desctiption text-start w-100">
            <span class="webinar" >「{{ webinar.webinar_title }}」</span><br>
          </div>
          <div class="desctiption text-start w-100 ">
            <span class="company">{{ webinar.company_name }}</span>
          </div>
        </div>
        <div v-else :class="(webinar)" :id="webinar+index"></div>
      </div>
    </div>
    <span id="attendance-section"></span>
  </div>  
  </div>
  <div id="devider"></div>
<!-- Section 4 (attendance) -->
  <div id="attendance" class="mx-1">
    <div class="wrapper">
      <div id="section-title" class="section-title">
        <h3 class="text-white">受講方法</h3>
      </div>
      <div class="text-center mx-auto w-100">
        <button id="more-step-button" class="text-center mx-auto" @click="toogle_step_desctiption()" >
          <u v-if="is_step_opened">詳細を閉じる</u>
          <u v-else>詳しく見る</u>
        </button>
      </div>

      <div id="step">
        <div id="step-header" @click="toogle_step_desctiption()" :title="[(is_step_opened) ? '詳細を閉じる' : '詳しく見る']"><h4 class="ms-2 fs-4 fw-bolder">STEP1. 受講者登録をする</h4></div>
        <div id="step-description" :class="[(is_step_opened) ? '' : 'd-none']">
          <p class="ms-3 fw-bold">
            ▷ Webinar Weekに初めてご参加の方<br>
            本ページの <a class="click-effect" href="https://webinarweek.net/webinar/entry/?thema_pid=TH_KzOTAlP8"><img src='@/assets/attend-button.png'  alt='attend' style="max-width: 240px;"></a>より、受講者様の情報をご入力ください<br><br>
            ▷過去に開催したWebinar Weekに参加された方<br>
            受講者登録は不要です。STEP3にお進みください。<br>
          </p>
        </div>
      </div>
      <div class="text-center w-100 mb-2"><img src='@/assets/icon/down-arrow.png'  alt='down' style="max-width: 40px;"></div>
      
      <div id="step">
        <div id="step-header" @click="toogle_step_desctiption()" :title="[(is_step_opened) ? '詳細を閉じる' : '詳しく見る']"><h4 class="ms-2 fs-4 fw-bolder">STEP2. 受講する</h4></div>
        <div id="step-description" :class="[(is_step_opened) ? '' : 'd-none']">
          <p class="ms-3 fw-bold">
              ウェビナーの詳細ページの《受講/予約する》ボタンをクリックしてご視聴ください。 <br>
            </p>
        </div>
      </div>

      <div id="step" class="mt-5">
        <div id="step-header" class="text-center w_btn">
          <a href="https://webinarweek.net/webinar/entry/?thema_pid=TH_KzOTAlP8" target="_blank" class="text-white">
            受講者登録
          </a>
        </div>
      </div>

    </div>
  </div>
  <div id="devider"></div>
<!-- Section 8 (exhibiting companies) -->
<div id="exhibiting-companies-wrapper" class="px-2">
  <div id="section-title">
    <h3>参加企業一覧</h3>
  </div>
  <div class="wrapper exhibiting-companies row mx-auto">
    <div v-for="company in webinar_exhibitor" :key="company.public_id"
      class="item col-lg-6 col-12 p-2">
      <span @click="view_company(company.public_id)" >{{ company.company_name }}</span>
    </div>
    <!-- <h2 class="fw-bold text-center text-dark">準備中</h2> -->
    <div class="nav wrapper py-3 text-end">
          <router-link to="/company_list" class="text-decoration-none text-end text-dark">参加企業⼀覧<i class="fas fa-caret-right fa-lg ms-2"></i></router-link>
    </div>
  </div>

</div>
<!-- Section 9 (past webinar weeks) -->
  <div id="webinar-week-event" class="wrapper">
    <div id="section-title-container">
      <div id="section-title" class="section-title">
        <h3>これまでの Webinar Week</h3>
      </div>
      <div id="section-descripton" class="px-2">
        <h4><strong>Webinar Weekとは︖</strong></h4>
        <p>
          専⾨的でコンパクトなオンラインセミナーでリレーする、合同ウェビナー企画です。必要な情報を必要な⽅
          に届けることで、発信者と受信者を⾼い精度でマッチングすることを⽬指します。
        </p>
      </div>
    </div>
        <div id="ww-wrapper" class="row pt-3">
          <div class="col-12 col-lg-4 col-sm-6 px-lg-2 mt-2">
            <div id="card" class="text-center mx-auto position-relative">
              <img class="w-100 h-auto" src="@/assets/ww-1.jpg"  alt="money"><br>
              <p class="fw-bold mt-2">グリーンモールディング<br>ウェビナーウィーク2022 </p>
              <div class="text-start">
              <p>開催時期：2022.6/28~7/1 <br>
              延べ視聴者数：4,681⼈</p></div>
              <a href="https://webinarweek.net/ww/202201greenmolding/" target="_blank" class="w-100 btn rounded-0 click-effect text-white fw-bold">イベントサイト</a>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-sm-6 px-lg-2 mt-2">
            <div id="card" class="text-center mx-auto position-relative">
              <p class="info-archive">- アーカイブ配信中 -</p>
              <img class="w-100 h-auto" src="@/assets/ww-2.jpg" alt="money"><br>
              <p class="fw-bold mt-2">ものづくりDX 物流DX<br>ウェビナーウィーク2022 </p>
              <div class="text-start">
              <p>開催時期：2022.11/28~11/30  <br>
              延べ視聴者数：1,573⼈</p></div>
              <a href="https://webinarweek.net/ww/202211fldxww/" target="_blank" class="w-100 btn rounded-0 click-effect text-white fw-bold">イベントサイト</a>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-sm-6 px-lg-2 mx-auto mt-2">
            <div id="card" class="text-center mx-auto">
              <img class="w-100 h-auto" src="@/assets/ww-3.jpg" alt="money"><br>
              <p  class="fw-bold mt-2">バイオプラスティックによる<br>カーボンニュートラルへの挑戦</p>
              <div class="text-start">
              <p>開催時期：2023.2/8~2/9  <br>
              延べ視聴者数：2,651⼈</p></div>
              <a href="https://webinarweek.net/ww/202301bioplastic/" target="_blank" class="w-100 btn rounded-0 click-effect text-white fw-bold">イベントサイト</a>
            </div>
          </div>
        </div>
  </div>
  <div id="devider"></div>
</div>
</template>    
<script>
import _ from 'lodash';
import {Api} from '@/utiles/ApiConnect';
import {MDBContainer, MDBListGroup, MDBListGroupItem} from 'mdb-vue-ui-kit';
import '@/utiles/jquery.simpleTicker';
import dayjs from 'dayjs';

export default {
  data: function() {
    return {
      // テーマ情報
      thema_info: {
        title: '',
        description: '',
      },
      time: this.get_japan_time(),
      
      // Webinar一覧      
      webinar_list: {},

      merged_webinar_list: {},
      // Webinar現在開催中のウェビナー    
      currently_airing_webinar:{},
            
      // Webinar次のウェビナー
      next_webinar:{},
      
      // Webinarお知らせ一覧
      webinar_information: [],

      // Webinar事業一覧
      webinar_exhibitor: [],

      // Webinarジャンル一覧
      genre_list: [],

      // Webinar開幕日一覧
      day_list: ["2023-06-06","2023-06-07","2023-06-08"],

      // Webinar開幕日id
      active_day:3,

      // Webinar開幕日id
      mobile_active_day:0,

      // Webinar開幕時間一覧
      time_list: [],

      // boolean現在開催中のウェビナー情報表示
      is_airing_opened: false,

      // boolean次のウェビナー情報表示
      is_next_opened: false,

      // booleanステップの情報表示
      is_step_opened: true,
    };
  },

  components: {
    MDBContainer,
    MDBListGroup,
    MDBListGroupItem
  },

  /***
   * ライフサイクル
   */
  mounted: function() {
    this.start_time();
    this.getTimeList();
    this.getWebinarList();
    this.getInformation();
    this.getExhibitor();
    // this.updateActiveDay();
  },

  /***
   * メソッド
   */
  methods: {
    // time controller

    // JSTの時間を習得
    get_japan_time: function (){
      const now = new Date();
      const formatter = new Intl.DateTimeFormat('en-US', {
        dateStyle: 'short', 
        timeStyle: 'medium', 
        timeZone: 'Asia/Tokyo',
      });
      return new Date(formatter.format(now));
    },

    get_str_time_by_date: function (date){
      date = new Date(date); 
      return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+
        " "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
    },

    addtime: function (minute){
      if(minute<1){
        this.time.setSeconds(this.time.getSeconds() + (minute*60));
      }else{
        this.time.setMinutes(this.time.getMinutes() + minute);
      }
    },

    addminute: function (time,minute){
      if(minute<1){
        return time.setSeconds(this.time.getSeconds() + (minute*60));
      }else{
        return time.setMinutes(this.time.getMinutes() + minute);
      }
    },

    start_time: function (){
      this.interval = setInterval(async () => {
        // this.time = this.get_japan_time();
        var test = this.time.getTime()+1000;
        this.time = new Date(test);
        // pakai jika dat webinar sudah ada
        this.update_curenlty_airing();
        // this.update_curenlty_airing2();
        this.updateActiveDay();
      }, 1000)
    },

    // モバイル形表示
    showMobileTimeTableNav: function() {
      const timeTableNavs=document.querySelectorAll("#tt-nav");
      for (let i = 0; i < timeTableNavs.length; i++) {
        if(timeTableNavs[i].classList.contains("active")){
          return timeTableNavs[i];
        }
      }
    },

    // 表示されるタイムテーブルの取得
    getActiveTimeTable: function() {
      const timeTableNavs=document.querySelectorAll("#tt-nav");
      for (let i = 0; i < timeTableNavs.length; i++) {
        if(timeTableNavs[i].classList.contains("active")){
          return timeTableNavs[i];
        }
      }
    },

    //現在開催しているウェビナーを更新する
    update_curenlty_airing: function() {
      const mwl = this.merged_webinar_list;
      // C1
      const fw = mwl[0];
      if(this.time < new Date(fw.webinar_start_at)){
        this.currently_airing_webinar = {};
        this.next_webinar = fw;
        return;
      }
      // C4
      const lw = mwl[mwl.length - 1];
      if(this.time > new Date(lw.webinar_start_at)){
        this.currently_airing_webinar = lw;
        this.next_webinar = {};
        return;
      }
      let time = this.time;
      for (let i = 0; i<mwl.length-1;i++){
      // for (let webinar of mwl) {
        // C2
        if(time >= new Date(mwl[i].webinar_start_at) && time <= new Date(mwl[i].webinar_close_at)){
          this.currently_airing_webinar = mwl[i];
          this.next_webinar = mwl[i+1];
          return;
        }
        // C3
        if(time >= new Date(mwl[i].webinar_start_at) && time <= new Date(mwl[i+1].webinar_start_at)){
          this.currently_airing_webinar = {};
          this.next_webinar = mwl[i+1];
          return;
        }
      }
    },

    check_currently_airing_webinar: function() {
      return _.isEmpty(this.currently_airing_webinar);
    },

    check_next_webinar: function() {
      return _.isEmpty(this.next_webinar);
    },

    // booleanの関数を反対の相手の価値
    toogle_button_next: function() {
      this.is_next_opened = !this.is_next_opened;
    },

    // booleanの関数を反対の相手の価値
    toogle_button_airing: function() {
      this.is_airing_opened = !this.is_airing_opened;
    },

    // idで表示されるタイムテーブル変更
    toogleTimeTable: function (index) {
      this.active_day=index;
    },
    
    // booleanの関数を反対の相手の価値
    toogle_step_desctiption: function (){
      this.is_step_opened = !this.is_step_opened;
    },

    // Webinar一覧の取得
    getWebinarList: function() {
      // APIへ接続する。
      Api.connect(
          // 実行するメソッド名
          'Webinar.Search',
          // 引数の指定
          {},
      )
          // 実行結果の取得
          .done(function(result) {
            let webinar_list = {};
            let merged_webinar_list = [];
            _.forEach(result.data, function(obj) {
              let key_day = obj.webinar_start_at.substring(0, 10);
              if (key_day in webinar_list) {
                webinar_list[key_day].push(obj);
                webinar_list[key_day] = _.sortBy(webinar_list[key_day], ['webinar_start_at']);
              } else {
                webinar_list[key_day] = [obj];
              }
              merged_webinar_list.push(obj);
            });
            this.merged_webinar_list = _.sortBy(merged_webinar_list, (webinar) => webinar.webinar_start_at);
            let day_list = _.keys(webinar_list).sort();
            let tenpArray=[];
            let isExist=false;
            for (let i = 0 ; i<day_list.length;i++){
              tenpArray=[];
              for (let j = 0 ; j<this.time_list.length;j++){
                for (let k = 0 ; k<webinar_list[day_list[i]].length;k++){
                  isExist=false;
                  if(webinar_list[day_list[i]][k].webinar_start_at.substring(11, 16)==this.time_list[j]){
                    tenpArray.push(webinar_list[day_list[i]][k]);
                    isExist=true;
                    break;
                  }
                }
                if(!isExist){
                  tenpArray.push("skipped");
                }
              }
              webinar_list[day_list[i]]=tenpArray;
            }
            this.webinar_list = webinar_list;
            // this.day_list = day_list;
          }.bind(this));  
    },

    // Webinarお知らせの取得
    getInformation: function() {
      // APIへ接続する。
      Api.connect(
          // 実行するメソッド名
          'Information.Search',
          // 引数の指定
          {},
      )
          // 実行結果の取得
          .done(function(result) {
            this.webinar_information = _.slice(result.data, 0, 4);
          }.bind(this));
    },

    // Webinar事業者一覧の取得
    getExhibitor: function() {
      // APIへ接続する。
      Api.connect(
          // 実行するメソッド名
          'Exhibitor.Search',
          // 引数の指定
          {},
      )
          // 実行結果の取得
          .done(function(result) {
            let webinar_exhibitor = _.sortBy(result.data, ['company_name_read']);
            this.webinar_exhibitor = webinar_exhibitor;
            // let matsui = webinar_exhibitor.find(x => x.company_name === '株式会社松井製作所');
            // this.webinar_exhibitor = this.webinar_exhibitor.filter(x => x.company_name != "株式会社松井製作所");
            // // this.webinar_exhibitor = this.shuffle(this.webinar_exhibitor);
            // this.webinar_exhibitor.push(matsui);
          }.bind(this));
    },

    // Webinar詳細画面へ
    view_webinar(webinar_id) {
      this.$router.push('/webinar/' + webinar_id);
    },

    // news詳細へ
    view_info(info_id) {
      this.$router.push('/info/' + info_id);
    },

    // 事業者詳細へ
    view_company: function(company_id) {
      this.$router.push('/company/' + company_id);
    },
    
    // 配列シャッフルして取得
    shuffle: function(array) {
          let currentIndex = array.length,  randomIndex;
          // While there remain elements to shuffle.
          while (currentIndex != 0) {
            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
              array[randomIndex], array[currentIndex]];
          }
          return array;
    },

    // Webinar時間の取得
    getTimeList: function (strtime={hh:10,mm:0}){
      let time_list=[];
      let timeMinute = this.HourStrToMinute(strtime);
      for (let i = 0 ; i < 13; i++){
        time_list.push(this.MinuteToHourStr(timeMinute));
        timeMinute=timeMinute+30;
      }
      this.time_list = time_list;
    },

    // Webinar終了時間の取得
    getWebinarEndTime: function (strtime){
      let time = {hh:strtime.substring(0, 2),mm:strtime.substring(3)};
      let inMinute = this.HourStrToMinute(time);
      inMinute = inMinute + 25;
      return this.MinuteToHourStr(inMinute);
    },

    // 時間を30っ分たす
    add30minute: function (time) {
      let temp = this.HourStrToMinute(time);
      temp = temp + 30;
      temp = this.MinuteToHourStr(temp);
      return temp;
    },

    // 時間のテックスを分に変える
    HourStrToMinute: function (Time) {
        return (parseInt(Time.hh)*60) + 
        parseInt(Time.mm);
    },

    // 分を時間のテックスに変える
    MinuteToHourStr: function (minute){
        let time ={
        hh:Math.floor(minute / 60),
        mm:minute % 60
        }
        return this.getTimeText(time);
    },

    // 時間のテックスを習得
    getTimeText: function (temp) {
        let tempM;
        let tempH;
        if (temp.mm < 10) {
        tempM = `0${temp.mm}`;
        } else {
        tempM = `${temp.mm}`;
        }
        if (temp.hh < 10) {
        tempH = `0${temp.hh}`;
        } else {
        tempH = `${temp.hh}`;
        }
        return `${tempH}:${tempM}`;
    },

    // Webinar開幕日idを更新
    updateActiveDay: function (){
      let today = this.time;
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      const yyyy = today.getFullYear();
      today = yyyy + '-' + mm + '-' + dd;
      this.active_day=0;
      if ("2023-06-06" == today){
        this.active_day = 0;
      }else if("2023-06-07" == today){
        this.active_day = 1;
        // this.show_side_button = true;
      }else if("2023-06-08" == today){
        this.active_day = 2;
        // this.show_side_button = true;
      }
    }

  },
};
</script>
<style lang="scss">
@import "../../node_modules/mdb-vue-ui-kit/src/scss/index.free";
#clock{
  z-index: 99;
  position: absolute;
  border: solid 2px white;
  border-radius: 10px;
  box-shadow: 1px 1px 4px 5px rgba(255,255,255,1);
  padding: 10px;
  background-color: rgba(255,255,255,0.7);
  font-weight: bolder;
  letter-spacing: 2px;
  color: var(--primary);
}
#devider{
    height:80px;
    background-color:white;
    @include media-breakpoint-down(md) {
      height:40px;
    }
}
a {
    text-decoration: underline;
    color: #4f4f4f;
}
.nav a{
    color:black;
    margin:10px 0 10px auto;
      @include media-breakpoint-down(md) {
        margin:10px auto 10px auto;
      }
}
a.img_link:hover {
    opacity: 0.8;
}
a img{
    transition:all ease 0.3s;
}
a img:hover{
    transform: scale(1.02);
}
.section-title{
      background-image: url(@/assets/title-bg.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      text-align: center;
      margin: auto;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      @include media-breakpoint-down(md) {
        align-items: flex-start !important;
      }
      h3{
        font-size: 3.2rem;
        @include media-breakpoint-down(md) {
          font-size: 2.2rem !important;
        }
      }
  }
// Banner
#top_logo img{
  max-width:700px;
  @include media-breakpoint-down(md) {
    max-width:350px;
  }
  transition: all ease 0.5s;
}
#top_date {
  margin-top: 50px;
  text-shadow: 2px 2px 1px var(--secondary-08);
}
#side_button{
  color:white;
  font-weight: bold;
  background-color:var(--tertiary);
  cursor: pointer;
  border:none;
  // writing-mode: vertical-lr;
  // -ms-writing-mode: vertical-lr;
  // -webkit-writing-mode: vertical-lr;
  // -moz-writing-mode: vertical-lr;
  // text-orientation: upright;
  width: 50px !important;
  font-size: calc(1rem + 0.3vw) !important;
  @include media-breakpoint-down(md) {
  width: 40px !important;
  font-size: calc(1rem) !important;
    // font-size: calc(1rem + 0.3vw) !important;
  }
  transition: all ease 0.3s;
  :hover{
    background-color:var(--tertiary-08);
  }
}
#close_button{
  color:var(--tertiary-08);
  background-color:rgba(0,0,0,0);
  // height: 100%;
  position: absolute;
  font-weight: bolder;
  border:none;
  right: 0;
  top: 0;
  cursor: pointer;
  padding: 10px;
  transition: all ease 0.3s;
  :hover{
    color:var(--tertiary);
  }
}
.side_button_wrapper{
    position: absolute;
    margin-top: 20px;
    background-color: rgba(255,255,255,0.85);
    right: calc(50px - 50%);
    width: 50%;
    transition: all ease 0.5s;
    min-height: 190px;
    #side_button{
      min-height: 190px;
    }
    @include media-breakpoint-down(md) {
      right: calc(40px - 95%);
      width: 95%;
    }
}
.side_button_description{
  // white-space: nowrap; 
  // overflow: hidden; 
  // text-overflow: ellipsis;
  max-width: 600px;
  @include media-breakpoint-down(md) {
    max-width: 300px;
  }
}
#side_btn_link{
  cursor: pointer;
  text-decoration: underline;
  transition: all ease 0.3;
    text-shadow: -1px 0 rgba(0,0,0,0) rgba(0,0,0,0), 0 1px rgba(0,0,0,0), 1px 0 rgba(0,0,0,0), 0 -1px rgba(0,0,0,0);
  &:hover{
    color: var(--tertiary);
    // text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  }
}
#currently_airing_webinar{
    top: -80px;
  @include media-breakpoint-down(md) {    
  }
}
#next_webinar{
    top: 120px;
    @include media-breakpoint-down(md) {    
    }
}
.open_info{
  right:0 !important;
}
.move_logo{
  margin-right: 47%;
  @include media-breakpoint-down(md) {
    margin-right: 0;
  }
}
#hero_area {
  overflow: hidden;
  max-height: 700px;
  min-height: 500px;
  margin:auto;
  background-image: url(@/assets/hero-area.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: initial;
  background-position: center -300px;
  @include media-breakpoint-down(md) {
    background-size: cover;
    background-position: center center;
  }
  display: flex;
  align-items: flex-end;
  padding-bottom: 20px;
  .section-title{
      background-image: url(@/assets/title-bg.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      text-align: center;
      margin: auto;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      @include media-breakpoint-down(md) {
      align-items: center;
      }
  }
  .section-title h2{
    font-size: 3.2rem;
    span{
      font-size: 2.2rem;
      color: whitesmoke;
      @include media-breakpoint-down(md) {
        font-size: 1.8rem;
      }
    }
    @include media-breakpoint-down(md) {
      font-size: 2.5rem;
    }
  }
  @include media-breakpoint-down(md) {
    height: 60vh !important;
  }
}
#top-button{
  font-weight: bolder;
  padding: 5px 0px 5px 0px;
  border-radius: 50px;
  border: none;
  text-align: center;
  background-color: var(--secondary);
  color: white;
  letter-spacing: 2px;
  cursor: pointer;
  box-shadow: 0px 0px 5px 4px rgba(255,255,255,0);
  transition: all 0.25s ease;
  font-size: calc(1rem + 0.3vw) !important;
  @include media-breakpoint-down(md) {
  font-size: calc(1rem) !important;
  }
  &:hover {
    color:var(--secondary);
    background: white;
    box-shadow: 0px 0px 5px 4px var(--secondary);
  }
}
.top-date {
  display: flex;
  span{ 
    // text-shadow: 1px 1px 2px var(--primary), 0 0 1em white, 0 0 0.2em white;
    text-shadow: 3px 3px 5px rgba(255,255,255,0.85);
    font-weight: bolder;
    color:var(--primary)
  }
  #year{
    font-size: 2rem;
  }
  #date{
    font-size: 3rem;
  }
  #day{  
    font-size: 1.5rem;
    align-self: end;
    margin-bottom: .5rem;
  }
}
#top_view_logo {
  max-height: 60%;
  display: block;
  //margin: 0 20%;
  @include media-breakpoint-up(sm) {
    max-height: 80%;
  }
  @include media-breakpoint-up(lg) {
    max-height: 100%;
  }
}
#image_wrap {
  max-width: 90%;
  width: 1200px;
}
.date {
  position: absolute;
  bottom: 120px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 3rem;
  line-height: 1.8rem;
  text-shadow: 2px 1px rgb(0 0 0 / 40%);
  margin: 0;
  width: 100%;
  text-align: center;
  padding: 0.8rem 0 0.8rem 0;
  background-color:rgba(0,0,0,0.5);
  @include media-breakpoint-down(md) {
    font-size: 1.5rem;
    bottom: 30px;
  }

}
.date img{
  width: 3rem;
  @include media-breakpoint-down(md) {
    width: 1.5rem;
    bottom: 60px;
  }
}
// Possibility
#possibility{
  min-height:400px;
  max-height:600px;
  margin:auto;
  padding-bottom: 10px;
  background-image: url(@/assets/section-2.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  // sementara  
  display: flex;
  align-items: center;
  @include media-breakpoint-down(md) {
    max-height:initial;
  }
  #section-title {
    h3 {
      // padding: 3rem 0px 3rem 0px;
      font-weight: bold;
      font-size: 2.2rem;
      color: whitesmoke;
      @include media-breakpoint-down(md) {
        font-size: 1.5rem !important;
      }
    }
  }
  #section-text {
    padding: 10px 20px 0px 20px;
    font-weight: 500;
    .blue{
      color:#4472c4;
      font-weight: 600;
    }
    .green{
      color:#00b050;
      font-weight: 600;
    }
    p {
      color: whitesmoke;
      line-height: 2;
      font-size: 1.25rem;
      @include media-breakpoint-down(md) {
        padding: 0px 10px 0px 10px;
        font-size: 1rem;
      }
    }
  }
}
// time table
#webinar_table {
   background-color: #aeacd0;
  .genre_name {
    text-align: center;
    height: 100px;
    font-family: Anton;

    p {
      padding: 20px 10px;
      margin: 0;
      font-size: 1.5rem;
      line-height: 1.8rem;
    }
  }

  .webinar_area {
    padding: 3px 5px;

    .seminar_box {
      border: 1px solid #8DAB00;
      border-radius: 10px;
      padding-bottom: 5px;
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
      background-color: white;
      cursor: pointer;
      margin-bottom: 10px;

      div {
        padding: 3px 10px;
        line-height: 1.2rem;
      }

      .seminar_type {
        line-height: 1rem;
        font-weight: 300;
      }

      .seminar_title {
        font-weight: 700;
      }
    }
  }
}
#time-table-wrapper{
  @include media-breakpoint-down(md) {
    padding:1px 0px 10px 0px;
  }
}
.time-table {
  justify-content: center;
  max-width: 1200px;
  margin: auto;
  color:black;
  .nav{
    display: block;
    margin-top: auto;
  }
}

.time-table.mobile-nav{
  width:100%;
  display:none;
  @include media-breakpoint-down(md) {
    display:flex !important;
  }
  .item{
    width: calc(100%/3);
    text-align: center;
    border:solid;
    border-width: 0px 0px medium medium ;
    background-color: #b7b7b7;
    border-color: white;
    cursor:pointer;
    transition:all ease 0.3s;
    display:initial !important;
  }
  .item:hover{
    background-color:#141084;
    border-color: #141084;
  }
  .item.active{
      background-color:#141084;
      border-color: #141084;
  }
  h3{
    font-weight: normal;
    color:white;
    padding: 5px 0px 5px 0px !important;
    margin: 0px !important;
  }
}
.time-table-mobile {
    display:none !important;
  @include media-breakpoint-down(md) {
    display:block !important;
    padding:20px 0 20px 0;
    background-color:#aeacd0;
  }
}

#desktop_time_table{
    display:initial;
  @include media-breakpoint-down(md) {
    display:none;
  }
}
#mobile_time_table{
    display:none;
  @include media-breakpoint-down(md) {
    display:initial;
  }
  button{
    border: none;
    cursor: pointer;
    display: block;margin-top: auto;
    align-items: center;
    justify-content: center;
  }
  .nav-even{
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.4);
  }
}
.time-title{
  width: 100%;
  height: 100%;
  background-color: var(--primary-08);
  border-color: var(--primary-08);
  display: flex;
  justify-content: center;
  align-items: center;
}
.item{
  padding:0 !important;
}  
.item.show {
  display:initial;
}
.item.bg-d9{
  background-color: var(--primary-03);
}
.item.bg-d8{
  background-color:  var(--primary-03);
}
.nav{
  height:50px;
  transition: all ease 0.3s;
  h4{
    // color:black;
    color:white;
    margin: auto;
    text-align: center;  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.nav-odd{
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  text-shadow: 2px 2px rgba(243, 243, 243, 0.4);
}
.bg_odd{
  background-color: var(--primary-06);
  border-color: var(--primary-06);
}
.nav-even{
  background-color: var(--primary-05);
  border-color: var(--primary-05);
}
.bg_even{
  background-color: var(--primary-03);
  border-color: var(--primary-03);
}
.time-card{
  height: 225px;
  margin: 1rem 0 1rem 0;
  // container
  display: flex;
  justify-content: center;
  padding: 1rem;
  margin: 1rem;
  @include media-breakpoint-down(md) {
    padding: 1rem 0 1rem 0;
    margin: 1rem 0 1rem 0;
  } 
  // accecoris
  // font
  span{
    color:white;
    font-size: 1.5rem;
    letter-spacing: 1px;
    @include media-breakpoint-down(md) {
    font-size: 1.3rem;
    } 
    @include media-breakpoint-down(sm) {
    font-size: 1rem;
    } 
  }
}
.webinar-card{
  // container
  height: 225px;
  border-radius: 1rem;
  margin: 1rem;
  // accesoris
  background-color:white;
  // box-shadow: 0rem 0.25rem 0.5rem rgba(0,0,0,0.1);
  border:solid 0.5px var(--primary-05);
  box-shadow: 0rem 0.25rem 0.5rem var(--primary-03);
  // animation
  cursor: pointer;
  transition:all ease 0.3s;
  .desctiption{
    .webinar{
    // font
    font-weight: bold;
    }
    padding: 0.2rem 1rem 0.2rem 1rem;
  }
} 
.webinar-card:hover{
  border:solid 0.5px var( --primary-08);
  box-shadow: 0rem 0.25rem 0.8rem var( --primary-08);
  transform: scale(1.02);
}
.skipped{
  height: 40px;
  margin: 0px !important;
  padding: 0px !important;
}
#skipped9{
  height: 225px;
  border-radius: 1rem;
  margin: 1rem;
}
// attendance
#attendance{
  padding: 20px 0px 20px 0px;
  // background-color: var(--primary-02);
  background-image:url("@/assets/section-3.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right center;
  // background-attachment: fixed;
  padding: 10px;
}
// step
#more-step-button{
  padding: 0;
  color:rgba(255, 255, 255, .8); 
  border: none;
  background: none;
  transition: all ease 0.3s;
}
#more-step-button:hover{
  color:whitesmoke; 
}
#step{
  margin-bottom: 1.5rem;
}
#step-header{
  cursor: pointer;
  padding: 10px;
  background-color: white;
  color: var(--primary);
  box-shadow: inset 5px 5px 5px rgba(0, 0, 0, 0.1);
}
#step-description{    
  background-color: rgba(230,241,245,0.9);
  padding: 20px;
  transition: all ease 0.3s;
  height: auto;
}

// partner
.partner{
  // container
  max-width: 1308px;
  margin: auto;
  .item img{
    height:auto;
    width:100%;
  }
  .nav{
    width:100%;
    a{
      margin:30px 0px 30px 0px;
      margin-left:auto;
    }
    @include media-breakpoint-down(md) {
      a{
        margin-left:auto;
        margin-right:auto;
        text-align:center;
      }
    }
  }
  a:not(.img-link) {
      color: black;
      &::after {
        background-color: black;
      }
      &:hover::after {
        color: black;
      }
  }
}
#exhibiting-companies-wrapper{
  // background-color:var(--primary-02);
  background-image:url("@/assets/section-5.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right center;
  padding-top: 40px;
  padding-bottom: 40px;
  #section-title h3{
    color: whitesmoke;
  }
  @include media-breakpoint-down(md) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .exhibiting-companies{
    margin: auto; 
    background-color: rgba(255,255,255,0.8);
    border-radius: 20px;
    padding: 20px;
    @include media-breakpoint-down(md) {
      padding-left:1rem;
    }
    .item{
      cursor:pointer;
    }
    .item:hover{
      font-weight: bolder;
    }
  }
}
.webinar-week-event-banner{
  img{
    width: 100%;
    height: auto;
  }
}
/* webinar-week-event */
.click-effect{
    transition: all ease 0.3s;
    -webkit-box-shadow: 0 8px 15px rgba(0, 0, 0, 0);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0);
}
.click-effect:hover{
    -webkit-transform: translate(0, 1px);
    transform: translate(0, 1px);
    color: #fff;
    -webkit-box-shadow: 0 8px 8px rgba(0, 0, 0, .2);
    box-shadow: 0 8px 8px rgba(0, 0, 0, .2);
}
#webinar-week-event #title h2{
    color: var(--primary-color) !important;
}
#webinar-week-event .section-title h3{
  @include media-breakpoint-down(md) {
      font-size: 1.2rem !important;
      padding: 1.7rem 0px 0rem 0px;
    }
}
#ww-wrapper{
    max-width: 900px;
    margin: auto;
  .info-archive {
      position: absolute;
      background-color: rgba(255,255,255,0.8);
      color: red;
      font-weight: bold;
      letter-spacing: 2px;
      width: calc(100% - 20px);
  }
}
#webinar-week-event #card{
    border-radius: 0px;
    padding: 10px;
    min-height: 250px;
    max-width: 375px;
    font-weight: normal;
    color: black;
    box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.2);
}
#webinar-week-event #card a{
    background-color: var(--primary);
    box-shadow: inset 0px 0px 3px  rgba(0, 0, 0, 0.5);
}
</style>
